const PING_INTERVAL = 15 * 60 * 1000;
const MAX_CONSECUTIVE_FAILURES = 2;

let lastPingAt = Date.now();
let failureCount = 0;

async function refreshCsrfToken() {
    try {
        const response = await window.axios.get('/csrf-token');
        const newToken = response.data.csrf_token;

        lastPingAt = Date.now();
        failureCount = 0;

        if (newToken) {
            const meta = document.head.querySelector('meta[name="csrf-token"]');
            if (meta) {
                meta.setAttribute('content', newToken);
            }

            document.querySelectorAll('input[name="_token"]').forEach(function (input) {
                input.value = newToken;
            });

            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = newToken;
        }

        hideConnectionWarning();
        return true;
    } catch (error) {
        failureCount++;
        if (failureCount >= MAX_CONSECUTIVE_FAILURES) {
            showConnectionWarning();
        }
        return false;
    }
}

function showConnectionWarning() {
    const banner = document.getElementById('connection-warning');
    if (banner) {
        banner.style.display = 'flex';
    }
}

function hideConnectionWarning() {
    const banner = document.getElementById('connection-warning');
    if (banner) {
        banner.style.display = 'none';
    }
}

function showSessionExpiredModal() {
    const modal = document.getElementById('session-expired-modal');
    if (modal) {
        modal.style.display = 'flex';
    }
}

setInterval(refreshCsrfToken, PING_INTERVAL);

document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
        const elapsed = Date.now() - lastPingAt;
        if (elapsed > PING_INTERVAL) {
            refreshCsrfToken();
        }
    }
});

let isSubmitting = false;

document.addEventListener('submit', function (event) {
    const form = event.target;
    const tokenInput = form.querySelector('input[name="_token"]');

    if (!tokenInput || isSubmitting) return;

    const elapsed = Date.now() - lastPingAt;
    if (elapsed > PING_INTERVAL) {
        event.preventDefault();
        isSubmitting = true;

        refreshCsrfToken().then(function (success) {
            isSubmitting = false;
            if (success) {
                HTMLFormElement.prototype.submit.call(form);
            } else {
                showSessionExpiredModal();
            }
        });
    }
}, true);

export { refreshCsrfToken, showSessionExpiredModal };
